import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import PrimeButton from "@components/PrimeButton";

// CSS
import "./ConfirmationDialog.scss";

function ConfirmationDialog({
  showConfirmDialog = false,
  header = "common.areYouSure",
  bodyTemplate,
  handleYesEvent,
  handleCloseEvent,
  positiveButtonLabel = "Yes",
  positiveButtonDisable = false,
  negativeButtonLabel = "No",
  positiveButtonLoader = false,
  width = "35vw",
  height = null,
  customCSSClass = {},
  showHeaderCloseIcon = true,
  extraButtonLabel = null,
  extraButtonIcon = "pi pi-trash",
  handleExtraEvent = null,
}) {
  const { t } = useTranslation();
  const renderFooter = () => (
    <div>
      <PrimeButton
        label={t(negativeButtonLabel)}
        icon="pi pi-times"
        onClick={() => handleCloseEvent()}
        className="p-button-text font-medium-poppins"
      />
      {extraButtonLabel && handleExtraEvent && (
        <PrimeButton
          label={t(extraButtonLabel)}
          icon={extraButtonIcon}
          onClick={() => handleExtraEvent()}
          className="p-button-text font-medium-poppins"
          disabled={positiveButtonLoader}
        />
      )}
      <PrimeButton
        label={t(positiveButtonLabel)}
        icon="pi pi-check"
        onClick={() => handleYesEvent()}
        autoFocus
        className="font-medium-poppins"
        disabled={!positiveButtonDisable}
        loading={positiveButtonLoader}
      />
    </div>
  );

  return (
    <Dialog
      header={t(header)}
      visible={showConfirmDialog}
      style={{ width, height, ...customCSSClass }}
      footer={renderFooter()}
      onHide={() => handleCloseEvent(false)}
      draggable={false}
      closable={showHeaderCloseIcon}
      resizable={false}
    >
      {bodyTemplate && bodyTemplate}
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  showConfirmDialog: PropTypes.bool,
  header: PropTypes.string,
  positiveButtonLabel: PropTypes.string,
  positiveButtonDisable: PropTypes.bool,
  negativeButtonLabel: PropTypes.string,
  positiveButtonLoader: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  customCSSClass: PropTypes.shape({}),
  showHeaderCloseIcon: PropTypes.bool,
  extraButtonLabel: PropTypes.string,
  extraButtonIcon: PropTypes.string,
  handleExtraEvent: PropTypes.func,
};

export default ConfirmationDialog;
